import { QuestionPlanIsChangeOnlyOption as Question } from "@/components/features/items/edit/plan/_shared/ui/components/plan-attributes/is-only-change-option";

import { usePlanIsChangeOnlyOption } from "./hooks";

export const QuestionPlanIsChangeOnlyOption = () => {
	const { isChangeOnlyOption, onSetIsChangeOnlyOption } = usePlanIsChangeOnlyOption();

	return <Question isChangeOnlyOption={isChangeOnlyOption} onSetIsChangeOnlyOption={onSetIsChangeOnlyOption} />;
};

QuestionPlanIsChangeOnlyOption.displayName = "QuestionPlanIsChangeOnlyOption";
